var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import SchedulerCourseSectionService from "../Domain/SchedulerCourseSection/SchedulerCourseSection.service";
import CourseSectionDomainService from "../Domain/CourseSection/CourseSection.service";
import CourseSectionFullDomainService from "../Domain/CourseSectionFull/CourseSectionFull.service";
// There is a bunch of methods using this frontend service to call a different service endpoint, we need to change it but I won't don't right now
const COURSE_URL = "/aviso/course";
const BASE_URL = "/aviso/courseSection";
const BASE_ADMIN_URL = "/aviso/adminCourseSection";
export default class CourseSectionService {
    static getSchedulerCourseSections(courseId, termId) {
        return FetchService.getSingleResponse(COURSE_URL + "/getSchedulerCourseSections", {
            courseId,
            termId,
        }).then(({ course, sections }) => ({
            course,
            sections: sections.map(SchedulerCourseSectionService.fromJson),
        }));
    }
    /**
     * This endpoint is kinda strange. It's very specific to the attendance page, and returns information specifically
     * for that page.  It's not recommended when information just about the course section is required.
     *
     * @param {CourseSectionId} courseSectionId - id of the course section
     * @returns {Promise<*>} - data returned from the endpoint
     */
    static getCourseSection(courseSectionId) {
        return FetchService.getSingleResponse("/aviso/advisor/courseSections", {
            courseSection: courseSectionId,
        }).then((resp) => {
            var _a;
            return (Object.assign(Object.assign({}, resp), { courseSections: (_a = resp.courseSections) === null || _a === void 0 ? void 0 : _a.map(CourseSectionDomainService.fromJSON) }));
        });
    }
    static getSchedulerCourseGroups(termId) {
        return FetchService.getSingleResponse(COURSE_URL + "/getSchedulerCourseGroups", { termId });
    }
    static getSchedulerCourses(termId) {
        return FetchService.getSingleResponse(COURSE_URL + "/getSchedulerCourses", {
            termId,
        });
    }
    static getCoursesInCourseGroup(groupId) {
        return FetchService.getSingleResponse(COURSE_URL + "/getCoursesInGroup", {
            groupId,
        });
    }
    static getCoursesInCourseGroups(groupIds) {
        return FetchService.getSingleResponse(COURSE_URL + "/getCoursesInGroups", {
            groupIds,
        });
    }
    static getListAsJson(params = {}) {
        return FetchService.getSingleResponse(BASE_URL + "/listAsJson", params);
    }
    static search(search = {}, options = {}) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield FetchService.getPagedResponse(BASE_URL + "/search", {
                onlyCurrentTerm: search === null || search === void 0 ? void 0 : search.onlyCurrentTerm,
                onlyMyCourses: search === null || search === void 0 ? void 0 : search.onlyMyCourses,
                fromDate: search === null || search === void 0 ? void 0 : search.fromDate,
                toDate: search === null || search === void 0 ? void 0 : search.toDate,
                instructorAffiliationIds: search === null || search === void 0 ? void 0 : search.instructorAffiliationIds,
                statusIds: search === null || search === void 0 ? void 0 : search.statusIds,
                academicCalendarIds: search === null || search === void 0 ? void 0 : search.academicCalendarIds,
                name: search === null || search === void 0 ? void 0 : search.name,
                code: search === null || search === void 0 ? void 0 : search.code,
                section: search === null || search === void 0 ? void 0 : search.section,
                query: search === null || search === void 0 ? void 0 : search.query,
                courseIds: search === null || search === void 0 ? void 0 : search.courseIds,
                ids: search === null || search === void 0 ? void 0 : search.ids,
                censusDateFrom: search === null || search === void 0 ? void 0 : search.censusDateFrom,
                censusDateTo: search === null || search === void 0 ? void 0 : search.censusDateTo,
                withdrawByDateFrom: search === null || search === void 0 ? void 0 : search.withdrawByDateFrom,
                withdrawByDateTo: search === null || search === void 0 ? void 0 : search.withdrawByDateTo,
                max: options === null || options === void 0 ? void 0 : options.max,
                offset: options === null || options === void 0 ? void 0 : options.offset,
                sort: options === null || options === void 0 ? void 0 : options.sort,
                order: options === null || options === void 0 ? void 0 : options.order,
            });
            return Object.assign(Object.assign({}, resp), { data: (_a = resp.data) === null || _a === void 0 ? void 0 : _a.map(CourseSectionDomainService.fromJSON) });
        });
    }
    static searchFull(search = {}, options = {}) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield FetchService.getPagedResponse(BASE_ADMIN_URL + "/search", {
                courseIds: search === null || search === void 0 ? void 0 : search.courseIds,
                section: search === null || search === void 0 ? void 0 : search.section,
                instructorAffiliationIds: search === null || search === void 0 ? void 0 : search.instructorAffiliationIds,
                academicCalendarIds: search === null || search === void 0 ? void 0 : search.academicCalendarIds,
                srcSystemId: search === null || search === void 0 ? void 0 : search.srcSystemId,
                lmsId: search === null || search === void 0 ? void 0 : search.lmsId,
                max: options === null || options === void 0 ? void 0 : options.max,
                offset: options === null || options === void 0 ? void 0 : options.offset,
                sort: options === null || options === void 0 ? void 0 : options.sort,
                order: options === null || options === void 0 ? void 0 : options.order,
            });
            return Object.assign(Object.assign({}, resp), { data: (_a = resp.data) === null || _a === void 0 ? void 0 : _a.map(CourseSectionFullDomainService.fromJSON) });
        });
    }
    static get(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(BASE_ADMIN_URL + "/get", {
                id,
            }).then(CourseSectionFullDomainService.fromJSON);
        });
    }
    static save(request) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_ADMIN_URL + "/save", request).then(CourseSectionFullDomainService.fromJSON);
        });
    }
}
